import { KeycloakInstance } from 'keycloak-js';

export interface UserInfo {
  sub: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

/**
 * Estrae le informazioni dell'utente dal token JWT di Keycloak
 * @param keycloak Istanza di Keycloak
 * @returns Informazioni utente o null se non loggato
 */
export const getUserInfo = (keycloak: KeycloakInstance): UserInfo | null => {
  if (!keycloak?.authenticated || !keycloak.tokenParsed) {
    return null;
  }

  const token = keycloak.tokenParsed as any;

  return {
    sub: token.sub,
    email: token.email || '',
    firstName: token.given_name || '',
    lastName: token.family_name || '',
    roles: token.realm_access?.roles || token.roles || [],
  };
};

/**
 * Verifica se l'utente ha un ruolo specifico
 * @param keycloak Istanza di Keycloak
 * @param role Nome del ruolo da verificare (es: 'ADMIN', 'EMPLOYEE')
 * @returns true se l'utente ha il ruolo, false altrimenti
 */
export const hasRole = (keycloak: KeycloakInstance, role: string): boolean => {
  const userInfo = getUserInfo(keycloak);
  if (!userInfo) {
    console.warn(`[hasRole] No user info found. Keycloak authenticated: ${keycloak?.authenticated}`);
    return false;
  }

  const hasIt = userInfo.roles.includes(role);
  console.log(`[hasRole] Checking role "${role}". User roles:`, userInfo.roles, `Result: ${hasIt}`);
  return hasIt;
};

/**
 * Verifica se l'utente è admin
 * @param keycloak Istanza di Keycloak
 * @returns true se l'utente ha il ruolo ADMIN o admin
 */
export const isAdmin = (keycloak: KeycloakInstance): boolean => {
  const result = hasRole(keycloak, 'admin') || hasRole(keycloak, 'ADMIN');
  console.log(`[isAdmin] Result: ${result}`);
  return result;
};

/**
 * Verifica se l'utente è dipendente
 * @param keycloak Istanza di Keycloak
 * @returns true se l'utente ha il ruolo EMPLOYEE o employee
 */
export const isEmployee = (keycloak: KeycloakInstance): boolean => {
  return hasRole(keycloak, 'employee') || hasRole(keycloak, 'EMPLOYEE');
};

/**
 * Log per debugging - mostra i ruoli dell'utente nel console
 * @param keycloak Istanza di Keycloak
 */
export const debugUserRoles = (keycloak: KeycloakInstance): void => {
  const userInfo = getUserInfo(keycloak);
  if (userInfo) {
    console.log('User Info:', {
      email: userInfo.email,
      name: `${userInfo.firstName} ${userInfo.lastName}`,
      roles: userInfo.roles,
    });
  } else {
    console.log('User not authenticated');
  }
};
